import { useEffect, useRef, useState } from 'react';
import { Box, Grid, Icon, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import {  VForm, useVForm, VTextFieldData,  IVFormErrors, AutoCompleteCliente, AutoCompleteFabrica } from '../../../shared/forms';
import { FerramentasDeDetalheVendas } from '../../../shared/components';
import { LayoutBaseVendas } from '../../../shared/layouts';
import { v4 as uuidv4 } from 'uuid';
import Alert from '@mui/material/Alert';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { TalaoService } from '../../../shared/services/api/vendas/Talao/Talao';
import PDFTalao from './ImpressaoTalao';
import PDFTalaoPequeno from './ImpressaoTalaopequena';

interface IFormData {
  idcli: string;
  idfabrica: string;
  datalan: Date;
  numero: number;
}
interface IitensPedidoDiretoDialog {
  iditens: string;
  descricao: string;
  quantidade: number;
}
interface IItensids {
  iditens: string;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'numero'>> = yup.object().shape({
  idcli: yup.string().required(),
  datalan: yup.date().required(),
  idfabrica: yup.string().required(),
});
export const DetalheTalaoPedido: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [statuss, setStatuss] = useState(true);
  const [rows, setRows] = useState<IitensPedidoDiretoDialog[]>([]);
  const [rowsids, setRowsids] = useState<IItensids[]>([]);
  const [venda, setvenda] = useState<boolean | null>();
  const [edit, setEdit] = useState(false);
  const [tipo, setTipo] = useState('p.ean');
  const [uuidcli, setUuidcli] = useState('');
  const [idfabrica, setIdfabrica] = useState('');
  const [codigobarra, setcodigobarra] = useState('');
  const codigoref = useRef<HTMLInputElement>(null);
  const qtdref = useRef<HTMLInputElement>(null);
  const nomeref = useRef<HTMLInputElement>(null);
  const [quantidade, setQuantidade] = useState('');
  const [openalert, setOpenAlert] = useState(false);
  const [msg, setMsg] = useState('');
  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      TalaoService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
            navigate('/talaopedido');
          } else {
            formRef.current?.setData(result);
            setUuidcli(result.idcli);
            setRows(result.itens);
            if (result.itens.length != 0) {
              setEdit(true);
            } else {
              setEdit(false);
            }
          }
        });
    } else {
      formRef.current?.setData({
        datalan: new Date(),
      });
      setRows([]);
      setvenda(null);
      setStatuss(true);
      setEdit(false);
    }
  }, [id]);

  useEffect(() => {
    codigoref.current?.focus();
  }, [formRef]);

  const handleSave = (dados: IFormData) => {
    if (rows.length != 0) {
      formValidationSchema.
        validate(dados, { abortEarly: false })
        .then((dados) => {
          setIsLoading(true);
          if (id === 'novo') {
            TalaoService
              .create(dados, rows)
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  setMsg(result.message);
                  setOpenAlert(true);
                } else {
                  if (isSaveAndClose()) {
                    navigate('/talaopedido');
                  } else {
                    navigate(`/talaopedido/${result}`);
                  }
                }
              });
          } else {
            TalaoService
              .updateById(id, dados, rows, rowsids)
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  setMsg(result.message);
                  setOpenAlert(true);
                } else {
                  if (isSaveAndClose()) {
                    navigate('/talaopedido');
                  }
                }
              });
          }
        })
        .catch((errors: yup.ValidationError) => {
          const validationErrors: IVFormErrors = {};
          errors.inner.forEach(error => {
            if (!error.path) return;
            validationErrors[error.path] = error.message;

          });
          formRef.current?.setErrors(validationErrors);
        });
    } else {
      setMsg('A saída deve conter no mínimo um ítem.');
      setOpenAlert(true);
    }
  };

  const handleDeleteEntrada = (id: string) => {
    if (confirm('Realmente deseja apagar?')) {
      TalaoService.deleteById(id)
        .then(result => {
          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
          } else {
            setMsg('Registro apagado com sucesso!');
            setOpenAlert(true);
            navigate('/talaopedido');
          }
        });
    }
  };
  const handleDelete = (id: string) => {
    if (confirm('Realmente deseja apagar?')) {
      const meuObjeto = { iditens: id };
      rowsids.push(meuObjeto);
      const indexToDelete = rows.findIndex((item) => item.iditens === id);
      if (indexToDelete !== -1) {
        const updatedList = [...rows];
        updatedList.splice(indexToDelete, 1);
        setRows(updatedList);
        if (updatedList.length != 0) {
          setEdit(true);
        } else {
          setEdit(false);
        }
      }
    }
  };
  type RowsType = IitensPedidoDiretoDialog[];

  const handleItens = (dados: IitensPedidoDiretoDialog) => {
    const index = rows.findIndex((listItem) => listItem.iditens === dados.iditens);
    let updatedList: RowsType;
    if (index !== -1) {
      updatedList = [...rows];
      updatedList[index] = dados;
    } else {
      updatedList = [dados, ...rows ];
    }
    setRows(updatedList);
    if (updatedList.length != 0) {
      setEdit(true);
    } else {
      setEdit(false);
    }
  };
  const handleuuidCli = (uuid: string | undefined) => {
    if (uuid != null) {
      setUuidcli(uuid);
    }
  };
  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };
  const handleImpressao = (id: string) => {
    TalaoService.Impressao(id)
      .then(result => {
        if (result instanceof Error) {
          alert(result.message);
        } else {
          PDFTalao(result);
        }
      });
  };
  const handleImpressaoPequena = (id: string) => {
    TalaoService.Impressao(id)
      .then(result => {
        if (result instanceof Error) {
          alert(result.message);
        } else {
          PDFTalaoPequeno(result);
        }
      });
  };
  const handlefabrica = (uuidfabrica: string | undefined) => {
    if (uuidfabrica != null) {
      setIdfabrica(uuidfabrica);
    } else {
      setIdfabrica('');
    }
  };
  return (
    <LayoutBaseVendas
      barraDeFerramentas={
        <FerramentasDeDetalheVendas
          textoBotaoNovo='Novo'
          mostrarBotaoImpressaoCarregando1={false}
          mostrarBotaoImpressaopequeno={false}
          mostrarBotaoImpressao1={false}
          mostrarBotaoImpressaoCarregando={isLoading}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoSalvarEFechar
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoImpressao={id !== 'novo'}
          disableBotaoSalvar={statuss ? isLoading : true}
          disableBotaoSalvarEFechar={statuss ? isLoading : true}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/talaopedido')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmNovo={() => navigate('/talaopedido/novo')}
          mostrarBotaoNovoCarregando={isLoading}
          aoClicarEmApagar={() => handleDeleteEntrada(id)}
          aoClicarEmImpressao={() => handleImpressao(id)}
          aoClicarEmImpressaopequeno={() => handleImpressaoPequena(id)}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Snackbar
            open={openalert}
            autoHideDuration={1200}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleCloseAlert}
              severity="error"
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={1} spacing={1}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container item direction="row" spacing={1.2} >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1.2} >
                  <Grid item xs={6} sm={12} md={6} lg={2} xl={2}>
                    <VTextFieldData
                      fullWidth
                      name='datalan'
                      label='Data do Lançamento'
                      disabled={isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={12} md={6} lg={6} xl={5}>
                    <AutoCompleteCliente
                      isExternalLoading={isLoading}
                      uuidcli={handleuuidCli}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <AutoCompleteFabrica
                      uuidfabrica={handlefabrica}
                      isExternalLoading={isLoading}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={6} xl={6}>
                    {tipo === 'p.ean' && (
                      <TextField
                        fullWidth
                        size='small'
                        value={codigobarra}
                        label='Descricao'
                        inputRef={codigoref}
                        disabled={isLoading}
                        onChange={e => setcodigobarra(e.target.value)}
                       onKeyDown={(e) => {
                        if (e.key === 'Enter' && codigobarra.trim() !== '') {
                          qtdref.current?.focus();
                        }
                      }}
                      />
                    )}
                  </Grid> 
                  <Grid item xs={6} sm={6} md={2} lg={2} xl={1}>
                    <TextField
                      fullWidth
                      value={quantidade}
                      inputRef={qtdref}
                      disabled={isLoading}
                      onChange={(e) => { setQuantidade(e.target.value); }}
                      size='small'
                      label='Quantidade' onKeyDown={(e) => {
                          if (e.key === 'Enter' && quantidade.trim() !== '') {
                            handleItens({
                              iditens: uuidv4(),
                              quantidade: Number(quantidade),
                              descricao: codigobarra,
                            })
                            codigoref.current?.focus();
                            setcodigobarra('');
                            setQuantidade('');
                          }
                        }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 700,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    overflowY: 'auto',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#cbd5e1 transparent',
                    '&::-webkit-scrollbar': {
                      width: 6,
                    },
                    '&::-webkit-scrollbar-track': {
                      background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#cbd5e1',
                      borderRadius: 10,
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#94a3b8',
                    },
                  }}
                >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow
                        sx={{
                          '& th': {
                            backgroundColor: theme =>
                              theme.palette.mode === 'light'
                                ? '#eff6ff'   
                                : '#334155',   

                            color: theme =>
                              theme.palette.mode === 'dark'
                                ? '#e2e8f0'  
                                : '#475569',  

                            fontSize: '0.75rem',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            letterSpacing: '0.04em',

                            borderBottom: '2px solid',
                            borderColor: theme =>
                              theme.palette.mode === 'light'
                                ? '#bfdbfe'
                                : '#475569',  

                            py: 1.5,
                            px: 2,

                            '&:first-of-type': {
                              borderTopLeftRadius: '8px',
                              borderLeft: '1px solid',
                              borderLeftColor: theme =>
                                theme.palette.mode === 'light'
                                  ? '#bfdbfe'
                                  : '#475569',
                            },

                            '&:last-of-type': {
                              borderTopRightRadius: '8px',
                              borderRight: '1px solid',
                              borderRightColor: theme =>
                                theme.palette.mode === 'light'
                                  ? '#bfdbfe'
                                  : '#475569',
                            },
                          },
                        }}
                      >
                        <TableCell style={{}} align='left'>Quantidade</TableCell>
                        <TableCell style={{}} align='left'>Descrição</TableCell>
                        <TableCell align="center">AÇÕES</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map(row => (
                        <TableRow key={row.iditens}
                          hover
                          sx={{ cursor: 'pointer' }}
                        >
                          <TableCell align='left' >{row.quantidade.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                          <TableCell align='left' >{row.descricao}</TableCell>
                          <TableCell align='center' >
                            <IconButton disabled={statuss ? isLoading : true} size="small" onClick={() => { handleDelete(row.iditens); }}>
                              <Icon>delete</Icon>
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      {isLoading && (
                        <TableRow>
                          <TableCell colSpan={6}>
                            <LinearProgress variant='indeterminate' />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </VForm>
    </LayoutBaseVendas>
  );
};